import React, { Component } from 'react';
import { Container, Row, Col, Section, SmallText, HeadingFive } from '../../legacy/hui/src/styled';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const SectionBunnings = Section.extend`
  background-color: #0d5257;
`;

export const SectionTop = Section.extend`
  background-color: #07464a;
  height: 16px;
  border-top: 1px solid #106b72;
`;

const FooterLinkWrapper = styled.div`
  text-align: center;
  margin: 1rem 0;
  color: white;
  a {
    text-decoration: underline;
    color: inherit;
    &:hover {
      color: inherit;
    }
  }
`;

const Title = styled(HeadingFive)`
  font-weight: bold;
  color: #fff;
`;

export class FooterBunnings extends Component {
  static propTypes = {
    siteSource: PropTypes.string,
    path: PropTypes.string
  };
  render() {
    const { siteSource, path } = this.props;
    return (
      <div>
        <SectionBunnings>
          <Container>
            <Row>
              <Col xs={0} md={2} lg={3} />
              <Col xs={12} md={8} lg={6}>
                {path !== '/error' && (
                  <FooterLinkWrapper>
                    <Title> Privacy </Title>
                    <SmallText>
                      This booking platform is operated by Hipages Pty Ltd (Hipages) as service
                      provider to Bunnings Group Limited (Bunnings). Hipages and Bunnings may
                      collect and share your personal information with each other in connection with
                      your use of this booking platform.
                    </SmallText>
                    <SmallText>
                      All information will be handled in accordance with each party’s privacy
                      policy, available at:{' '}
                      <a href="https://www.homeimprovementpages.com.au/privacy">
                        https://www.homeimprovementpages.com.au/privacy{' '}
                      </a>
                      {` `}and {` `}
                      <a href="https://www.bunnings.com.au/privacy-policy">
                        https://www.bunnings.com.au/privacy-policy
                      </a>
                      . From time to time, Bunnings or Hipages may contact you to seek feedback on
                      your use of this service
                    </SmallText>
                  </FooterLinkWrapper>
                )}
              </Col>
            </Row>
          </Container>
        </SectionBunnings>
        <SectionTop />
      </div>
    );
  }
}
